import axios from 'axios';

import settings from '../libs/config';
import ApiError from './apiError.js';
import Logger from "../functions/logging";

const endpointUser = settings.api_host + "/user";
const endpointUserEmail = settings.api_host + "/user/email";
const endpointUserZipcode = settings.api_host + "/user/zipcode";
const endpointUserDemos = settings.api_host + "/user/demographics";
const endpointUserContentProfile = settings.api_host + "/user/content/profile";
const endpointUserProfilePrivacy = settings.api_host + "/user/profile_privacy";
const endpointUserPasswordUpdate = settings.api_host + "/user/password/update";
const endpointGetUserMonitor = settings.api_host + "/user/monitor";
const endpointUpdateUserMonitor = settings.api_host + "/user/monitor/update";
const endpointUpdateUserSubscriptions = settings.api_host + "/user/subscription";
const endpointInitUserQuestionAssignment = settings.api_host + "/user/question_assignment";
const endpointUpdateUserQuestionAssignment = settings.api_host + "/user/question_assignment";
const endpointCompleteAllUserQuestionAssignments = settings.api_host + "/user/question_assignment_all";

const endpointTerminateUser = settings.api_host + "/event/terminate";
const endpointUpdateUserDisclaimer = settings.api_host + "/user/metadata";
const endpointUpdateViewerMetadata = settings.api_host + "/user/metadata";
const endpointGetAllUserQuestionAssignments = settings.api_host + "/user/question_assignments";
// const endpointGetUserDisclaimer = settings.api_host + "/user/metadata/get";

// const endpointGetUserMonitor = "http://127.0.0.1:7071" + "/user/monitor";
// const endpointUpdateUserMonitor = "http://127.0.0.1:7071" + "/user/monitor/update";
// const endpointUserDemos = "http://127.0.0.1:7071" + "/user/demographics";
// const endpointUserProfilePrivacy = "http://127.0.0.1:7071" + "/user/profile_privacy";
// const endpointUserPasswordUpdate = "http://127.0.0.1:7071" + "/user/password/update";

const FILE_NAME = "user.js";

export const getUser = async (user_token) => {
	if (!user_token) throw new Error("Missing User Token");
	try {
		const response = await axios.get(endpointUser, {
			params: {
				user_token
			}
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const isEmailInUse = async (params) => {
	const { email, group, test } = params;
	if (!email) {
		throw new Error("Missing Email");
	}
	try {
		const response = await axios.get(endpointUserEmail, {
			params: {
				email,
				group_id: group ? group._id.valueOf() : null,
				test
			}
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const getLocationByZipcode = async (zipcode) => {
	if (!zipcode) {
		throw new Error("Missing zipcode");
	}
	try {
		const response = await axios.get(endpointUserZipcode, {
			params: {
				zipcode
			}
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const updateUserDemographics = async (userData, user_token) => {
	let { hhi, education, ethnicity, user_id } = userData;
	
	if (!user_token) throw new Error("Missing User Token");
	if (!user_id) throw new Error("Missing User ID");
	if (!hhi && !education && !ethnicity) {
		throw new Error("Must update at lest one of the following: HHI, Education, or Ethnicity");
	}

	let params = { user_id: user_id, user_token: user_token};
	if (hhi) params.hhi = hhi;
	if (education) params.education = education;
	if (ethnicity) params.ethnicity = ethnicity;

	try {
		const response = await axios.get(endpointUserDemos, {
			params: params
		});

		const data = response.data;
		return data.result;
	} catch(error) {
		throw new ApiError(error);
	}
};

export const updateProfilePrivacy = async (userData, user_token) => {
	let { feedback_basic, feedback_pro, user_id } = userData;

	if (!user_token) throw new Error("Missing User Token");
	if (!user_id) throw new Error("Missing User ID");
	if (!userData.feedback_pro && userData.feedback_pro !== 0) throw new Error("Missing Feedback Pro Value");
	if (!userData.feedback_basic && userData.feedback_basic !== 0) throw new Error("Missing Feedback Basic Value");
	
	try {
		const response = await axios.get(endpointUserProfilePrivacy, {
			params: {
				feedback_basic, feedback_pro, user_id, user_token
			}
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const updateUserPassword = async (userData, user_token) => {
	let { new_password, old_password, email, user_id } = userData;
	if (!user_token) throw new Error("Missing User Token");
	if (!email) throw new Error("Missing User Email");
	if (!user_id) throw new Error("Missing User ID");
	if (!new_password) throw new Error("Missing New Password");
	if (!old_password) throw new Error("Missing Old Password");

	const params = {
		email, 
		new_password, 
		old_password, 
		user_id, 
		user_token
	};

	try {
		const response = await axios({
			method: 'post',
			url: endpointUserPasswordUpdate,
			data: params,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const getUserMonitor = async (user_id, user_token) => {
	if (!user_id) throw new Error("Missing User ID");
	if (!user_token) throw new Error("Missing User Token");
	let state = 'get';
	try {
		const response = await axios.get(endpointGetUserMonitor, {
			params: { user_id, user_token, state }
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const updateUserMonitor = async (user_id, user_token, points, last_view) => {
	if (!user_id) throw new Error("Missing User ID");
	// if (!points) throw new Error("Missing User Points");
	if (!user_token) throw new Error("Missing User Token");
	let state = "update";
	try {
		const response = await axios.get(endpointUpdateUserMonitor, {
			params: { user_id, points, last_view, user_token, state }
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const terminateUser = async (params) => {
	try {
		const response = await axios({
			method: 'post',
			url: endpointTerminateUser,
			data: params,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const updateUserContentProfile = async (profile, user_token) => {
	if (!user_token) throw new Error("Missing User Token");
	if (!profile) throw new Error("Missing User data");
	// if (!profile.user_id) throw new Error("Missing User ID");
	if (!profile.group_id) throw new Error("Missing Group ID");

	let params = {
		user_token: user_token,
		// user_id: profile.user_id,
		group_id: profile.group_id,
		title: profile.title,
		panel_segment: profile.panel_segment,
		device_id: profile.device_id,
		device: profile.device,
		episode_id: profile.episode_id,
		time: profile.time,
		state: profile.state,
		browser: profile.browser
	};

	try {
		const response = await axios({
			method: 'post',
			url: endpointUserContentProfile,
			data: params,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}

};

export const updateUserDisclaimer = async(user_id, user_token, panel_segment, group_id, disclaimers, metadata, method) => {
	if (!user_id) throw new Error("Missing User ID");
	if (!panel_segment) throw new Error("Missing Panel Segment Index");
	if (!group_id) throw new Error("Missing Group Id");
	if (!user_token) throw new Error("Missing User Token");
	if (!disclaimers) throw new Error("Missing User Disclaimers");

	try {
		const response = await axios.get(endpointUpdateUserDisclaimer, {
			params: { user_id, user_token, panel_segment, group_id, disclaimers, metadata, method }
		});

		const data = response.data;
		return data.result;
	} 
	catch (error) {
		throw new ApiError(error);
	}
};

export const updateViewerMetadata = async (user_id, user_token, panel_segment, group_id, metadata, method) => {
	if (!user_id) throw new Error("Missing User ID");
	if (!panel_segment && panel_segment !== 0) throw new Error("Missing Panel Segment Index");
	if (!group_id) throw new Error("Missing Group Id");
	if (!user_token) throw new Error("Missing User Token");

	try {
		const response = await axios.get(endpointUpdateViewerMetadata, {
			params: { user_id, user_token, panel_segment, group_id, metadata, method }
		});

		const data = response.data;
		return data.result;
	}
	catch(error) {
		throw new ApiError(error);
	}
};

export const updateUserSubscription = async (user_id, user_token, data) => { 
	if (!user_token) throw new Error("Missing User Token");
	if (!user_id) throw new Error("Missing User ID");
	if (!data.group_id) throw new Error("Missing Group ID");

	const params = {
		user_token,
		user_id,
		...data,
	};

	try {
		const response = await axios({
			method: 'post',
			url: endpointUpdateUserSubscriptions,
			data: params,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const initUserQuestionAssignment = async (user_id, user_token, data) => {
	if (!user_token) throw new Error("Missing User Token");
	if (!user_id) throw new Error("Missing User ID");
	if (!data.group_id) throw new Error("Missing Group ID");

	const params = {
		user_token,
		user_id,
		...data,
	};

	try {
		const response = await axios({
			method: 'post',
			url: endpointInitUserQuestionAssignment,
			data: params,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});
		return response.data.result;
	}
	catch (error) {
		throw new ApiError(error);
	}
};

export const updateUserQuestionAssignment = async (user_id, user_token, data) => {
	if (!user_token) throw new Error("Missing User Token");
	if (!user_id) throw new Error("Missing User ID");
	if (!data.group_id) throw new Error("Missing Group ID");
	if (!data.survey_id) throw new Error("Missing Survey ID");
	if (!data.versions) throw new Error("Missing Versions Array");

	const params = {
		user_token,
		user_id,
		...data,
	};

	try {
		const response = await axios({
			method: 'put',
			url: endpointUpdateUserQuestionAssignment,
			data: params,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		const responseData = response.data;
		return responseData.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const getAllUserQuestionAssignments = async (user_id, user_token, data) => {
	if (!user_token) throw new Error("Missing User Token");
	if (!user_id) throw new Error("Missing User ID");
	if (!data.group_id) throw new Error("Missing Group ID");
	if (!data.survey_id) throw new Error("Missing Survey ID");

	try {
		const params = {
			user_token,
			user_id,
			...data,
		};

		const response = await axios.get(endpointGetAllUserQuestionAssignments, {
			params: params
		});

		const responseData = response.data;
		return responseData.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const completeAllUserQuestionAssignments = async (user_id, user_token, data) => {
	if (!user_token) throw new Error("Missing User Token");
	if (!user_id) throw new Error("Missing User ID");
	if (!data.group_id) throw new Error("Missing Group ID");
	if (!data.survey_id) throw new Error("Missing Survey ID");

	const params = {
		user_token,
		user_id,
		...data,
	};

	try {
		const response = await axios({
			method: 'put',
			url: endpointCompleteAllUserQuestionAssignments,
			data: params,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};


// WEBPACK FOOTER //
// ./src/api/user.js